module.exports = __webpack_public_path__ + "static/img/zleepers-1.2521394.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/zleepers-1.jpg
// module id = 0U4x
// module chunks = 1